__turbopack_context__.v({
  "className": "notosans_9e584a59-module__g6-2-G__className",
  "variable": "notosans_9e584a59-module__g6-2-G__variable",
});
